export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const WAITING_FOR_GPS = 'WAITING_FOR_GPS';

export default {
  setUserLocation(latLng) {
    return {
      type: SET_USER_LOCATION,
      payload: latLng,
    };
  },

  waitingForGps(status) {
    return {
      type: WAITING_FOR_GPS,
      payload: status,
    };
  },
};
